// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaUploadState__uploader-a101d6 {
  color: var(--addition-50);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background-color: var(--addition-40_60);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.MediaUploadState__icon-c266d9 {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaUploadState/MediaUploadState.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".uploader {\n  color: var(--addition-50);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  background-color: var(--addition-40_60);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploader": `MediaUploadState__uploader-a101d6`,
	"icon": `MediaUploadState__icon-c266d9`
};
module.exports = ___CSS_LOADER_EXPORT___;
